import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import TecProductListCompare from "@tecumseh/Widgets/productlist/TecProductListCompare";
import TecProductListImage from "@tecumseh/Widgets/productlist/TecProductListImage";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    ImageAndSpecialwrapper?: InjectableCss;
    specialAlert?: InjectableCss;
    CompareButton?: InjectableCss;
    circleIcon?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            /* padding-bottom: 10px; */
        `,
    },
    imageWrapper: {
        css: css`
            > div {
                height: 100%;
            }
            margin: auto;
            padding: 8px 0;
            border: 1px solid ${COLORS.gainsboro};
            width: 100%;
            border-radius: 7px;
            /* flex: 1; */
            height: 245px;
            position: relative;
            img {
                object-fit: contain;
                width: auto;
                max-width: 100%;
                height: auto;
                aspect-ratio: 2.16/2.45;
                /* border: 1px solid ${COLORS.gainsboro}; */
                background-color: ${COLORS.background.base};
                border-radius: 7px;
                max-height: 100%;
            }
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            /* position: relative; */
        `,
    },
    specialAlert: {
        css: css`
            position: absolute;
            width: auto;
            bottom: 10px;
            font-family: ${TYPOGRAPHY.fontFamily.base};
            padding: 6px;
            border-radius: 0px 20.5px 20.5px 0px;
            opacity: 1;
            background-color: ${getColor("primary")};
            color: ${COLORS.white};
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            text-align: center;
            line-height: ${TYPOGRAPHY.lineHeight.vSmallestbase};
            padding-left: 12px;
            &:hover .circleIcon {
                background: ${COLORS.yellow};
                border: 0.25px solid rgba(17, 41, 69, 0.22);
                box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
            }
        `,
    },
    circleIcon: {
        css: css`
            width: 11px;
            margin-left: 11px !important;
            height: 11px;
            border-radius: 50%;
            display: inline-block;
            position: relative;
            margin: auto;
            left: 0px;
            border-radius: 5.499547px;
            border: 0.25px solid rgba(17, 41, 69, 0.219214);
            opacity: 1;
            background-color: ${COLORS.background.whiteSmoke};
            box-shadow: 0px 0px 2px rgb(0 0 0 / 64%);
        `,
    },
    CompareButton: {
        css: css`
            text-align: center;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    productInfo,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                    <TecProductListImage
                        showImage={showImage}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                    />
                    {product.productNumber && (
                        <StyledWrapper {...styles.specialAlert}>
                            <Clickable href={productInfo.productDetailPath} data-test-selector="productNumber">
                                {product.productNumber}
                                <Typography {...styles.circleIcon} className="circleIcon"></Typography>
                            </Clickable>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.CompareButton}>
                <TecProductListCompare showCompare={showCompare}></TecProductListCompare>
            </StyledWrapper>
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            {/* <ProductListActions showAddToList={showAddToList} showPrice={showPrice} /> */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
